export const activityStatuses = [
    { value: 'all', label: 'All' },
    { value: 'matched', label: 'Matched' },
    { value: 'notMatched', label: 'Not Matched' },
];
